



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// REJECTCUSTOMER
// REJECTCUSTOMER


const REJECTCUSTOMER= createAsyncThunk(
  "rejectCustomer/rejectCustomer",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectCustomerSlice = createSlice({
  name: "rejectCustomerSlice",
  initialState: {
    rejectCustomer: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectCustomer: (state) => {
        state.rejectCustomer.loading = false
        state.rejectCustomer.error = false
        state.rejectCustomer.data = []
        state.rejectCustomer.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTCUSTOMER.fulfilled, (state, action) => {
      state.rejectCustomer = {
        ...state.rejectCustomer,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTCUSTOMER.pending, (state, action) => {
      state.rejectCustomer = {
        ...state.rejectCustomer,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTCUSTOMER.rejected, (state, action) => {
      state.rejectCustomer = {
        ...state.rejectCustomer,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectCustomerAction = {
    REJECTCUSTOMER,
};

export { rejectCustomerAction };
export default rejectCustomerSlice.reducer;
export const {setInitialStateOfrejectCustomer} = rejectCustomerSlice.actions
